module.exports = __webpack_public_path__ + "eecede0807839c760b0bb45dd64a067d.MP3";